import Axios from "axios/index"

export default {
  async getToken(token) {
    return Axios.get('https://www.innexta.it/api/federlegno.php?token=' + token).then(async (res) => {
      return res.data
    })
  },
  async incentives(sector = "", region = "", aim = "") {
    return Axios.get(process.env.VUE_APP_FASI_URL + 'incentives?area=' + sector + '&region=' + region + '&finality=' + aim).then(async (res) => {
      return res.data
    })
  },
  async item(id) {
    return Axios.get(process.env.VUE_APP_FASI_URL + 'incentives/' + id).then(async (res) => {
      return res.data
    })
  },
  async regions() {
    return Axios.get(process.env.VUE_APP_FASI_URL + 'regions').then(async (res) => {
      return res.data
    })
  },
  async areas() {
    return Axios.get(process.env.VUE_APP_FASI_URL + 'areas').then(async (res) => {
      return res.data
    })
  },
  async finalities() {
    return Axios.get(process.env.VUE_APP_FASI_URL + 'finalities').then(async (res) => {
      return res.data
    })
  },
}
